import { DeliveryView } from "@/libs/tours-detail/views/DeliveryView";
import { useParams } from "react-router-dom";

export function DeliveryStopPage() {
  const { id, stopId } = useParams<{ id: string; stopId: string }>();

  if (!id || !stopId) {
    return null;
  }

  return <DeliveryView tourId={id} stopId={stopId} />;
}
